import { BiographiesPage } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.BIOGRAPHIES.path,
      name: "BioGraphies",
      key: routesMap.BIOGRAPHIES.path,
      private: false,
      element: <BiographiesPage />,
    },
  ];
}
